// Module
var code = "<div class=\"paymentMethods_item t-paymentMethods_item -iDeal\"> <cBillingForm :customer=\"customer\" :form=\"form\" :order=\"order\" payment-type=\"iDeal\" :provider-account=\"providerAccount\" :selected-payment=\"selectedPayment\" :theme=\"theme\" :url=\"url\"/> </div> ";
// Exports
export default code;